import { render, staticRenderFns } from "./ActionTypeProfile.vue?vue&type=template&id=780b2d7e&scoped=true"
import script from "./ActionTypeProfile.vue?vue&type=script&lang=js"
export * from "./ActionTypeProfile.vue?vue&type=script&lang=js"
import style0 from "./ActionTypeProfile.vue?vue&type=style&index=0&id=780b2d7e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b2d7e",
  null
  
)

export default component.exports